module.exports = __webpack_public_path__ + "img/ISO27001-cert-1.d8746e8a.jpg";